<template>
  <v-row>
    <v-col cols="12">
      <v-expansion-panels focusable>
        <v-expansion-panel v-for="(etape, index) in etapes" :key="index">
          <template
            v-if="
              (!campagnePrecoce && etapes[index].numEtape > 0) ||
                (campagnePrecoce && etapes[index].numEtapePrecoce > 0)
            "
          >
            <v-expansion-panel-header class="titreEtape grey lighten-4">
              <template v-slot:actions>
                <v-icon class="icon" :color="colorUnivLille">$expand</v-icon>
              </template>
              <span v-if="!campagnePrecoce" class="header"
                >Étape {{ etapes[index].numEtape }} :
                {{ etapes[index].header }} ...</span
              >
              <span v-else class="header"
                >Étape {{ etapes[index].numEtapePrecoce }} :
                {{ etapes[index].header }} ...</span
              >
            </v-expansion-panel-header>
            <v-expansion-panel-content class="subtitle-2 font-weight-light">
              <div v-html="etapes[index].text"></div>
            </v-expansion-panel-content>
          </template>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "InfoSeReorienter",
  props: ["campagnePrecoce"],
  data() {
    return {
      colorUnivLille: "#1f8388",
      etapes: [
        {
          numEtape: 1,
          numEtapePrecoce: 0,
          header:
            "se poser les bonnes questions avant de changer d'orientation",
          text:
            "<p>Faites le point sur ce qui n'a pas fonctionné dans votre formation actuelle et essayez d'identifier les raisons pour lesquelles vous envisagez ce changement : est-ce un problème de rythme ? de contenu ? Les cours sont-ils trop théoriques ou plus adaptés à votre projet ?</p><p>Faites également le point sur vos envies, vos passions, vos compétences, sur ce qui vous pousse ou vous freine dans la vie. Cette phase est incontournable pour la construction de votre projet d'études et professionnel.</p><p><b>Attention</b>, la réorientation n'est pas de droit. Nous vous conseillons de <b>ne pas abandonner</b> la formation dans laquelle vous êtes actuellement inscrit et de <b>passer les examens du semestre</b>.</p>"
        },
        {
          numEtape: 2,
          numEtapePrecoce: 1,
          header:
            "vérifier que la formation envisagée est bien ouverte à la réorientation",
          text:
            "<p>Consultez la liste des formations ouvertes à la réorientation et prenez connaissance du contenu et des objectifs de chaque formation avant d’effectuer votre demande de réorientation.</p><a href='https://nextcloud.univ-lille.fr/index.php/s/FmjFzd3i7oBC8iE/download/R%C3%A9orientation-Formations-ouvertes.pdf' target='_blank'>Formations ouvertes.pdf</a>"
        },
        {
          numEtape: 3,
          numEtapePrecoce: 0,
          header:
            "assister à la réunion d’information (conseillée mais pas obligatoire)",
          text:
            "<p>Pour tout comprendre sur la réorientation (procédure et calendrier à suivre, attentes des enseignants...), nous vous proposons d'assister à une des réunions d'information prévues.</p><a href='https://nextcloud.univ-lille.fr/index.php/s/gxNY5xazg5yd6xS' target='_blank'>Calendrier des réunions d'information.pdf</a>"
        },
        {
          numEtape: 0,
          numEtapePrecoce: 2,
          header: "se connecter à l’application REO-SUAIO",
          text:
            "<p>L’application REO-SUAIO est accessible depuis votre ENT, puis 'Connexion Univ. Lille' en haut à droite.</p>"
        },
        {
          numEtape: 4,
          numEtapePrecoce: 0,
          header: "se connecter à l’application REO-SUAIO",
          text:
            "<p><b>Vous êtes étudiant interne ?</b> L’application REO-SUAIO est accessible depuis votre ENT, puis 'Connexion Univ. Lille' en haut à droite.</p><p><b>Vous êtes étudiant externe ?</b> Utilisez le lien 'Connexion Etudiant Externe' en haut à droite (Vous devrez d'abord créer un compte).</p>"
        },
        {
          numEtape: 5,
          numEtapePrecoce: 0,
          header: "s’inscrire et participer à un atelier",
          text:
            "<p>Avant d'effectuer votre demande de réorientation 'candidature', vous devez participer à un atelier de réorientation (réorientation vers un semestre 2). L'inscription à un atelier se fait depuis cette même application REO-SUAIO </p> <p> <b>Important</b> : merci de bien noter la date et l’heure de l’atelier ainsi que le campus et la salle où se déroulera l'atelier s'il est en présentiel. Des ateliers à distance peuvent être proposés ! Cet atelier sera l'occasion de :</p><ul><li>Comprendre la procédure à suivre ;</li><li>S’informer sur le contenu et les attendus de la formation visée ;</li><li>Echanger avec les autres étudiants présents à l’atelier ;</li><li>Bénéficier d’un accompagnement et des conseils d’un Chargé d’orientation ;</li><li>Concrétiser le projet d’études et professionnel par la rédaction d’une lettre de motivation.</li></ul>"
        },
        {
          numEtape: 6,
          numEtapePrecoce: 3,
          header: "saisir la demande de réorientation",
          text:
            "<p>Saisir votre candidature et joindre toutes les pièces demandées. Vous pouvez prévoir :</p><ul><li>une copie du certificat de scolarité de l’année en cours</li><li>les bulletins de terminale et les résultats du baccalauréat</li><li>une lettre de motivation</li><li>et d’autres pièces justificatives obligatoires/facultatives en fonction des formations</li></ul>"
        },
        {
          numEtape: 7,
          numEtapePrecoce: 4,
          header: "consulter l’état d’avancement de votre demande",
          text:
            "<p><b>Nous vous conseillons de consulter régulièrement vos mails</b> pour suivre l’avancement de votre demande. Une notification est générée automatiquement pour chacune des étapes de votre candidature.</p><p><b>Votre demande est acceptée, vous devez</b> :<ul><li>confirmer définitivement votre souhait d'intégrer cette formation et cela depuis l'application REO-SUAIO. Le relai scolarité procédera à la modification de votre inscription administrative;</li><li>alerter le CROUS du changement de formation;</li><li>prendre contact avec le secrétariat pédagogique de la nouvelle formation;</li><li>assister aux cours (CM, TD et TP) de ma nouvelle formation selon le calendrier reçu par mon nouveau secrétariat.</li></ul></p><p><b>Votre demande n'est pas acceptée, vous pouvez</b> :<ul><li>prendre rendez-vous avec un.e Chargé.e d’orientation ou un.e Psychologue de l’éducation nationale des relais Orientation de l’Université de Lille.<br/>Vous trouverez les contacts en bas de <a href='https://www.univ-lille.fr/formation/sinformer-sorienter' target='_blank'>cette page</a>.</li></ul></p>"
        }
      ]
    };
  },
  methods: {
    getNumeroEtape() {}
  }
};
</script>

<style scoped>
.titreEtape {
  color: #1f8388;
  font-weight: bold;
}
.icon {
  order: 0;
}
.header {
  order: 1;
}
</style>
